import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'common/environment/environment.dev';
import { map, lastValueFrom } from 'rxjs';
import { EncryptionDecryption } from 'common/utils/encrdecr.utility';
import { ToasterService } from './toaster.service';
import { ToastController } from '@ionic/angular';
import { API_URL } from 'common/constants/url.constants';
import { keyToken, KmamcSubscriptionKey, plexUToken, updateCugApiEndPoint } from 'common/constants/app.constant';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    constructor(private http: HttpClient) { }

    prepareHeaders(contentType: string[] = []): HttpHeaders {
        let headers = new HttpHeaders();
        contentType.forEach((header) => {
            if (header !== 'Authorization' && header !== 'securityKey' && header) {
                headers = headers.set('Content-Type', header);
            } else if (header == 'Authorization') {
                headers = headers.set('Authorization', `Basic ${plexUToken}`);
                headers = headers.set('Content-Type', 'application/json');
            }

            if (header === 'securityKey') {
                headers = headers.set('securityKey', keyToken);
            }

            if (header === 'Kmamc-Subscription-Key') {
                headers = headers.set('Kmamc-Subscription-Key', KmamcSubscriptionKey);
                headers = headers.set('Content-Type', 'application/json');
            }
        });
        return headers;
    }

    prepareUrl(url: string) {
        if (url.startsWith('/')) {
            return environment.platform === 'web' ? url : environment.appUrl + url;
        } else return url;
    }

    getData(url: string): Promise<any> {
        const source = this.http.get<any>(this.prepareUrl(url), { headers: this.prepareHeaders(), responseType: url.startsWith('/kotakbh') ? ('text' as any) : 'json' }).pipe(
            map((data) => {
                data = url.startsWith('/kotakbh') || url.includes(environment.newPlexAPIEndpoint) ? this.decryptData(data) : data;
                return url.startsWith('/kotakbh') || url.includes(environment.newPlexAPIEndpoint) ? JSON.parse(data) : data;
            })
        );
        return lastValueFrom(source);
    }

    deleteData(url: string): Promise<any> {
        return this.http.delete<any>(this.prepareUrl(url), { headers: this.prepareHeaders(), responseType: url.startsWith('/kotakbh') ? ('text' as any) : 'json' }).toPromise();
    }

    convertToFormData(object: any) {
        const formData = new FormData();
        Object.keys(object).forEach((item, index) => {
            if (item === 'data') {
                formData.append(item, JSON.stringify(object[item]));
            } else {
                if (object[item].length) {
                    for (let i = 0; i < object[item].length; i++) {
                        formData.append(item, object[item].item(i));
                    }
                } else {
                    formData.append(item, object[item]);
                }
            }
        });

        return formData;
    }

    postData(url: string | any, formData: any): Promise<any> {
        let headerType: string[] = [];
        if (url.startsWith(environment.transactionAPIEndpoint) || url.startsWith('/KOTAKDISAPI') || url.startsWith(environment.cugAPIEndpoint) || url.startsWith('/OnlineUATAPI') || url.startsWith('/INVESTOR')) {

            formData = url.startsWith('/KOTAKDISAPI') && url !== API_URL.submitOTM ? '"' + this.encryptData(formData) + '"' : this.encryptData(formData);

            API_URL.postSIPTransactionData === url ||
                API_URL.postLumpsumTransactionData === url ||
                API_URL.postSIPFirstTimeTransactionData === url ||
                API_URL.postLumpsumfirstTimeData === url ||
                API_URL.transactSTP === url ||
                API_URL.postSWPTransactionData === url ||
                API_URL.switchTransaction === url ||
                API_URL.redeemTransaction === url ||
                API_URL.postZBFTransactionData === url ||
                API_URL.submitOTM === url ||
                API_URL.stopTransaction === url
                ? headerType.push('application/json')
                : headerType.push('application/x-www-form-urlencoded');
        } else if (url.startsWith('/OTMAPI')) {
            headerType.push('Authorization');
        } else if (url === API_URL.validateOTP || url === API_URL.preLoginValidateOtP) {
            formData = this.encryptData(formData);
        } else {
            if (url.includes(API_URL.saveProfileInfo) || url.includes(API_URL.updateProfileInfo) || url.includes(API_URL.submitQuery)) {
                formData = this.convertToFormData(formData);
            } else {
                formData = formData;
            }
        }

        const urlParts = url.split('/');
        if (updateCugApiEndPoint.includes(urlParts[urlParts.length - 1])) {
            headerType.push('securityKey');
        }

        if (url.startsWith(environment.logicAPI)) {
            formData = { data: this.encryptData(formData) };
            headerType.push('Kmamc-Subscription-Key');
        }

        return this.http
            .post<any>(this.prepareUrl(url), formData, { headers: this.prepareHeaders(headerType), responseType: url.startsWith('/kotakbh') || url.startsWith(environment.logicAPI) ? ('text' as any) : 'json' })
            .pipe(
                map((data) => {
                    data =
                        url.startsWith(environment.transactionAPIEndpoint) || url.startsWith('/KOTAKDISAPI') || url.startsWith(environment.cugAPIEndpoint) || url.startsWith('/OnlineUATAPI') || url.startsWith('/kotakbh') || url.startsWith('/INVESTOR') || url.includes(API_URL.validateOTP) || [API_URL.preLoginValidateOtP].includes(url) || url.includes(environment.newPlexAPIEndpoint) || url.startsWith(environment.logicAPI)
                            ? JSON.parse(this.decryptData(data))
                            : data;

                    if (url.startsWith(environment.transactionAPIEndpoint)) {
                        if (url === API_URL.check_AdharSeeding || url === API_URL.fetchPanInfo) {
                            return data;
                        }
                        // added one more failure condition
                        if (data.msgTable && data.msgTable[0] && (data.msgTable[0]['Status'] === 'F' || data.msgTable[0]['Status'] === '999')) {
                            // this.showToaster(data.msgTable[0]['as_results'], 'success');
                            return data.msgTable[0]['as_results'];
                            //return null;
                        } else if (data.Table === null && data.Information && data.Information.Return_Msg) {
                            this.showToaster(data.Information.Return_Msg, 'success');
                            return null;
                        } else {
                            if (url === '/KMFUnification/api/admin/VALOTP' || url === API_URL.getEmpanelmentStatus || url === API_URL.postEmpImage || url === API_URL.submitFatca) {
                                return data.msgTable[0];
                            } else if (url === API_URL.getEmpDetails) {
                                return data.BROKERDET;
                            } else if (url === API_URL.postEmpanelment) {
                                return data;
                            } else if (url === API_URL.listBankMandate) {
                                return data.Success ? data.Success : this.showToaster('Some error occured getting bank mandates', 'error');
                            } else if (url === API_URL.validateVPA) {
                                return data;
                            } else if (API_URL.stopTransaction === url || API_URL.getNomineeDistributor == url || API_URL.bankMandateActions == url || url === API_URL.updateContact || url === API_URL.kotakOTMDetails) {
                                return data;
                            } else {
                                return data.Table;
                            }
                        }
                    }
                    return data;
                })
            )
            .toPromise();
    }

    getImage(apiUrl: string, type: any = 'blob'): Promise<any> {
        return this.http.get(this.prepareUrl(apiUrl), { responseType: type }).toPromise();
    }

    postUrlToError(url: string, postObj: any): Promise<any> {
        return this.http.post(url, postObj).toPromise();
    }

    encryptData(data: any) {
        const encrypted = new EncryptionDecryption().encrypt(data);
        return encrypted;
    }

    decryptData(data: any) {
        const decrypted = new EncryptionDecryption().decrypt(data);
        return decrypted;
    }

    showToaster(text: string, type: string = 'success') {
        const toast = new ToastController();
        const toaster = new ToasterService(toast);
        toaster.showToaster(text, type);
    }
}
